var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"電話番号","type":"text","rules":[_vm.rule.required('電話番号'), _vm.rule.phone]},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}})}
var staticRenderFns = []

export { render, staticRenderFns }